import { render } from "./AddMandature.vue?vue&type=template&id=076f1b18&ts=true"
import script from "./AddMandature.vue?vue&type=script&lang=ts"
export * from "./AddMandature.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__